/**
 * Number formatting utilities
 */

/**
 * Configuration for number formatting
 */
export const NUMBER_FORMATS = {
  // Weight formatting (2 decimal places)
  weight: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  // Meters formatting (4 decimal places)
  meters: {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  },
  // Generic decimal with 2 places
  decimal2: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  // Generic decimal with 4 places
  decimal4: {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  },
} as const;

/**
 * Date/time formatting configuration for displaying dates with full timestamp
 */
export const DATETIME_FORMAT = {
  year: 'numeric' as const,
  month: '2-digit' as const,
  day: '2-digit' as const,
  hour: '2-digit' as const,
  minute: '2-digit' as const,
  second: '2-digit' as const,
};
